export default __webpack_public_path__ + "static/media/logo.56391b51.png";